import { DomainProvider } from "@4uhub/lib4uhub";
import { RouteObject } from "react-router-dom";

import FileIntegration from "../pages/4uBus/Automations/FileIntegration/FileIntegrationForm/FileIntegration";
import FileIntegrationPage from "../pages/4uBus/Automations/FileIntegration/FileIntegrationPage";
import InvAccoPayLowerings from "../pages/4uBus/Logs/InvAccoPayLowerings/InvAccoPayLowerings";
import IpmTasyInternal from "../pages/4uBus/Logs/IpmTasyInternal/IpmTasyInternal";
import LogError from "../pages/4uBus/Logs/LogError/LogError";
import LogFileIntegration from "../pages/4uBus/Logs/LogFileIntegration/LogFileIntegration";
import IpmTasy from "../pages/4uBus/Logs/LogTasyIpm/IpmTasy";
import TasyIpm from "../pages/4uBus/Logs/LogTasyIpm/TasyIpm";
import MetricsDashboard from "../pages/4uBus/Logs/Monitoring/MetricsDashboard";
import NfeTotvs from "../pages/4uBus/Logs/NfeTotvs/NfeTotvs";
import TasyCalendarsLogsPage from "../pages/4uBus/Logs/TasyCalendars/TasyCalendarsLogsPage";
import TasyIpmInternal from "../pages/4uBus/Logs/TasyIpmInternal/TasyIpmInternal";
import AccessToken from "../pages/4uBus/Register/AccessToken/AccessTokenForm/AccessToken";
import AccessTokenPage from "../pages/4uBus/Register/AccessToken/AccessTokenPage";
import AccessToken4Uhub from "../pages/4uBus/Register/AccessToken4Uhub/AccessToken4UhubForm/AccessToken4Uhub";
import AccessToken4UhubPage from "../pages/4uBus/Register/AccessToken4Uhub/AccessToken4UhubPage";
import ProfileTasyBus from "../pages/4uBus/Register/ProfileTasyBus/ProfileTasyBusForm/ProfileTasyBus";
import ProfileTasyBusPage from "../pages/4uBus/Register/ProfileTasyBus/ProfileTasyBusPage";
import RestrictionRule from "../pages/4uBus/Register/ProfileTasyBus/RestrictionRule/RestrictionRuleForm/RestrictionRule";
import ProfileTasyBus4Uhub from "../pages/4uBus/Register/ProfileTasyBus4Uhub/ProfileTasyBus4UhubForm/ProfileTasyBus4Uhub";
import ProfileTasyBus4UhubPage from "../pages/4uBus/Register/ProfileTasyBus4Uhub/ProfileTasyBus4UhubPage";
import RelationShipForm from "../pages/4uBus/Relationships/DefaultRelationships/RelationShipForm/RelationShipForm";
import RelationShipPage from "../pages/4uBus/Relationships/DefaultRelationships/RelationShipPage";
import Schedule from "../pages/4uBus/Restrictions/Schedules/Schedule/Schedule";
import SchedulesPage from "../pages/4uBus/Restrictions/Schedules/SchedulesPage";
import RobotsExecutionsPage from "../pages/4uBus/Robots/List/Executions/RobotsExecutionsPage";
import RobotsListPage from "../pages/4uBus/Robots/List/RobotsListPage";
import WelcomePage from "../pages/welcomePage";
import ExamSendRulePage from "../pages/4uBus/Automations/ExamSendRule/ExamSendRulePage";
import ExamSendRule from "../pages/4uBus/Automations/ExamSendRule/ExamSendRuleForm/ExamSendRule";
import IServicePage from "../pages/4uBus/Register/IService/IServicePage";
import IService from "../pages/4uBus/Register/IService/IServiceForm/IService";
import IProcessesPage from "../pages/4uBus/Register/IProcesse/IProcessesPage";
import IProcesse from "../pages/4uBus/Register/IProcesse/IProcesseForm/IProcesse";
import RelationshipGroupPage from "../pages/4uBus/Relationships/RelationshipGroup/RelationshipGroupPage";
import RelationshipGroup from "../pages/4uBus/Relationships/RelationshipGroup/RelationshipGroupForm/RelationshipGroup";
import IntegrationRulePage from "../pages/4uBus/Automations/IntegrationRule/IntegrationRulePage";
import IntegrationRule from "../pages/4uBus/Automations/IntegrationRule/IntegrationRuleForm/IntegrationRule";
import ForubusVaccine from "../pages/4uBus/Logs/ForubusVaccine/ForubusVaccine";
import Refund from "../pages/4uBus/Logs/Refund/Refund";
import InvoiceServiceAgy from "../pages/4uBus/Logs/InvoiceServiceAgy/InvoiceServiceAgy";
import PatientEncounterExecuteRequest from "../pages/4uBus/Logs/PatientEncounterExecuteRequest/PatientEncounterExecuteRequest";
import PatientEncounterPsTransferRequest from "../pages/4uBus/Logs/PatientEncounterPsTransferRequest/PatientEncounterPsTransferRequest";
import ExamManagementNotificationLog from "../pages/4uBus/Logs/ExamManagementNotificationLog/ExamManagementNotificationLog";
import GerAcessoVisitControlPacient from "../pages/4uBus/Logs/GerAcessoVisitControlPacient/GerAcessoVisitControlPacient";
import GerAcessoVisitControlSector from "../pages/4uBus/Logs/GerAcessoVisitControlSector/GerAcessoVisitControlSector";
import GerAcessoVisitControlVisitor from "../pages/4uBus/Logs/GerAcessoVisitControlVisitor/GerAcessoVisitControlVisitor";
import NonLabExamsAvailable from "../pages/4uBus/Logs/NonLabExamsAvailable/NonLabExamsAvailable";
import NonLabExamsReceived from "../pages/4uBus/Logs/NonLabExamsReceived/NonLabExamsReceived";
import ServiceReceived from "../pages/4uBus/Logs/ServiceReceived/ServiceReceived";
import ResultsNonLabAvailable from "../pages/4uBus/Logs/ResultsNonLabAvailable/ResultsNonLabAvailable";
import ResultsNonLabReceived from "../pages/4uBus/Logs/ResultsNonLabReceived/ResultsNonLabReceived";
import SyncPersons from "../pages/4uBus/Logs/SyncPersons/SyncPersons";
import SyncTransaction from "../pages/4uBus/Logs/SyncTransaction/SyncTransaction";

const bus: RouteObject[] = [
  {
    index: true,
    element: <WelcomePage />,
  },
  {
    path: "register/accessTokens",
    element: (
      <DomainProvider value={{ domainName: "4ubususers" }}>
        <AccessTokenPage />
      </DomainProvider>
    ),
  },
  {
    path: "register/accessTokens/new",
    element: (
      <DomainProvider value={{ domainName: "4ubususers" }} actions={["Create"]}>
        <AccessToken />
      </DomainProvider>
    ),
  },
  {
    path: "register/accessTokens/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "4ubususers" }}>
        <AccessToken />
      </DomainProvider>
    ),
  },
  {
    path: "register/profileTasy",
    element: (
      <DomainProvider value={{ domainName: "restrictionruleprofile" }}>
        <ProfileTasyBusPage />
      </DomainProvider>
    ),
  },
  {
    path: "register/profileTasy/new",
    element: (
      <DomainProvider
        value={{ domainName: "restrictionruleprofile" }}
        actions={["Create"]}
      >
        <ProfileTasyBus />
      </DomainProvider>
    ),
  },
  {
    path: "register/profileTasy/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "restrictionruleprofile" }}>
        <ProfileTasyBus />
      </DomainProvider>
    ),
  },

  {
    path: "register/processes",
    element: (
      <DomainProvider value={{ domainName: "iprocesse" }}>
        <IProcessesPage />
      </DomainProvider>
    ),
  },
  {
    path: "register/processes/new",
    element: (
      <DomainProvider value={{ domainName: "iprocesse" }} actions={["Create"]}>
        <IProcesse />
      </DomainProvider>
    ),
  },
  {
    path: "register/processes/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "iprocesse" }}>
        <IProcesse />
      </DomainProvider>
    ),
  },

  {
    path: "register/services",
    element: (
      <DomainProvider value={{ domainName: "iservice" }}>
        <IServicePage />
      </DomainProvider>
    ),
  },
  {
    path: "register/services/new",
    element: (
      <DomainProvider value={{ domainName: "iservice" }} actions={["Create"]}>
        <IService />
      </DomainProvider>
    ),
  },
  {
    path: "register/services/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "iservice" }}>
        <IService />
      </DomainProvider>
    ),
  },

  {
    path: "register/accessTokens4uHub",
    element: (
      <DomainProvider value={{ domainName: "4ubususers" }}>
        <AccessToken4UhubPage />
      </DomainProvider>
    ),
  },
  {
    path: "register/accessTokens4uHub/new",
    element: (
      <DomainProvider value={{ domainName: "4ubususers" }} actions={["Create"]}>
        <AccessToken4Uhub />
      </DomainProvider>
    ),
  },
  {
    path: "register/accessTokens4uHub/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "4ubususers" }}>
        <AccessToken4Uhub />
      </DomainProvider>
    ),
  },
  {
    path: "register/profile4uhub",
    element: (
      <DomainProvider value={{ domainName: "restrictionruleprofile" }}>
        <ProfileTasyBus4UhubPage />
      </DomainProvider>
    ),
  },
  {
    path: "register/profile4uhub/new",
    element: (
      <DomainProvider
        value={{ domainName: "restrictionruleprofile" }}
        actions={["Create"]}
      >
        <ProfileTasyBus4Uhub />
      </DomainProvider>
    ),
  },
  {
    path: "register/profile4uhub/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "restrictionruleprofile" }}>
        <ProfileTasyBus4Uhub />
      </DomainProvider>
    ),
  },
  {
    path: "register/restrictionRule/:profileTasyId/:extensionCode/new",
    element: (
      <DomainProvider value={{ domainName: "restrictionruleprofile" }}>
        <RestrictionRule ParentExtensionCode="20" />
      </DomainProvider>
    ),
  },
  {
    path: "register/restrictionRule/:profileTasyId/:extensionCode/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "restrictionruleprofile" }}>
        <RestrictionRule ParentExtensionCode="20" />
      </DomainProvider>
    ),
  },
  {
    path: "register/restrictionRule4uhub/:profileTasyId/:extensionCode/new",
    element: (
      <DomainProvider value={{ domainName: "restrictionruleprofile" }}>
        <RestrictionRule ParentExtensionCode="56" />
      </DomainProvider>
    ),
  },
  {
    path: "register/restrictionRule4uhub/:profileTasyId/:extensionCode/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "restrictionruleprofile" }}>
        <RestrictionRule ParentExtensionCode="56" />
      </DomainProvider>
    ),
  },
  {
    path: "setRelationships/:name/:extension",
    element: (
      <DomainProvider value={{ domainName: "establishmentsetrelationship" }}>
        <RelationShipPage />
      </DomainProvider>
    ),
  },
  {
    path: "setRelationships/:name/:extension/new",
    element: (
      <DomainProvider value={{ domainName: "establishmentsetrelationship" }}>
        <RelationShipForm />
      </DomainProvider>
    ),
  },
  {
    path: "setRelationships/:name/:extension/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "establishmentsetrelationship" }}>
        <RelationShipForm />
      </DomainProvider>
    ),
  },
  {
    path: "setRelationships/relationshipGroup/:extension",
    element: (
      <DomainProvider value={{ domainName: "4uBusRelationshipGroup" }}>
        <RelationshipGroupPage />
      </DomainProvider>
    ),
  },
  {
    path: "setRelationships/relationshipGroup/:extension/new",
    element: (
      <DomainProvider value={{ domainName: "4uBusRelationshipGroup" }}>
        <RelationshipGroup />
      </DomainProvider>
    ),
  },
  {
    path: "setRelationships/relationshipGroup/:extension/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "4uBusRelationshipGroup" }}>
        <RelationshipGroup />
      </DomainProvider>
    ),
  },
  {
    path: "restriction/rule/:extension",
    element: (
      <DomainProvider value={{ domainName: "restrictionrule" }}>
        <SchedulesPage />
      </DomainProvider>
    ),
  },
  {
    path: "restriction/rule/:extension/new",
    element: (
      <DomainProvider
        value={{ domainName: "restrictionrule" }}
        actions={["Create"]}
      >
        <Schedule />
      </DomainProvider>
    ),
  },
  {
    path: "restriction/rule/:extension/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "restrictionrule" }}>
        <Schedule />
      </DomainProvider>
    ),
  },
  {
    path: "logs/accessDbObjectErrors",
    element: (
      <DomainProvider value={{ domainName: "accessdbobjecterrors" }}>
        <LogError />
      </DomainProvider>
    ),
  },
  {
    path: "logs/ipmxtasyinternal",
    element: (
      <DomainProvider value={{ domainName: "4ubuslogsipm" }}>
        <IpmTasyInternal />
      </DomainProvider>
    ),
  },
  {
    path: "logs/tasyxipminternal",
    element: (
      <DomainProvider value={{ domainName: "4ubuslogsipm" }}>
        <TasyIpmInternal />
      </DomainProvider>
    ),
  },
  {
    path: "logs/tasyxipm",
    element: (
      <DomainProvider value={{ domainName: "tasyipm" }}>
        <TasyIpm />
      </DomainProvider>
    ),
  },
  {
    path: "logs/ipmxtasy",
    element: (
      <DomainProvider value={{ domainName: "ipmtasy" }}>
        <IpmTasy />
      </DomainProvider>
    ),
  },

  {
    path: "logs/tasyCalendar",
    element: (
      <DomainProvider value={{ domainName: "forubuscchedctrllogs" }}>
        <TasyCalendarsLogsPage />
      </DomainProvider>
    ),
  },

  {
    path: "logs/examFilesLogIntegration",
    element: (
      <DomainProvider value={{ domainName: "4uBusexamfileslog" }}>
        <LogFileIntegration />
      </DomainProvider>
    ),
  },

  {
    path: "logs/monitoring",
    element: (
      <DomainProvider value={{ domainName: "4ubusmonitoring" }}>
        <MetricsDashboard />
      </DomainProvider>
    ),
  },

  {
    path: "logs/nfeTotvs",
    element: (
      <DomainProvider value={{ domainName: "totvslogs" }}>
        <NfeTotvs />
      </DomainProvider>
    ),
  },
  {
    path: "logs/invoiceLoweringTotvs",
    element: (
      <DomainProvider value={{ domainName: "totvstitlelowering" }}>
        <InvAccoPayLowerings />
      </DomainProvider>
    ),
  },
  {
    path: "logs/forubusVaccine",
    element: (
      <DomainProvider value={{ domainName: "forubusvaccinelog" }}>
        <ForubusVaccine />
      </DomainProvider>
    ),
  },
  {
    path: "logs/refund",
    element: (
      <DomainProvider value={{ domainName: "refundadmlog" }}>
        <Refund />
      </DomainProvider>
    ),
  },
  {
    path: "logs/invoiceServiceAgy",
    element: (
      <DomainProvider value={{ domainName: "invoiceserviceagy" }}>
        <InvoiceServiceAgy />
      </DomainProvider>
    ),
  },
  {
    path: "logs/patientEncounterExecuteRequest",
    element: (
      <DomainProvider value={{ domainName: "patientencounterexecuterequest" }}>
        <PatientEncounterExecuteRequest />
      </DomainProvider>
    ),
  },
  {
    path: "logs/patientEncounterPsTransferRequest",
    element: (
      <DomainProvider value={{ domainName: "patientencounterpstransferrequest" }}>
        <PatientEncounterPsTransferRequest />
      </DomainProvider>
    ),
  },
  {
    path: "logs/examManagementNotificationLog",
    element: (
      <DomainProvider value={{ domainName: "exammanagementnotificationlog" }}>
        <ExamManagementNotificationLog />
      </DomainProvider>
    ),
  },
  {
    path: "logs/syncPersons",
    element: (
      <DomainProvider value={{ domainName: "syncperson" }}>
        <SyncPersons />
      </DomainProvider>
    ),
  },

  {
    path: "logs/gerAcessoVisitControlPacient",
    element: (
      <DomainProvider value={{ domainName: "accesscontrolpacientsendlog" }}>
        <GerAcessoVisitControlPacient />
      </DomainProvider>
    ),
  },

  {
    path: "logs/gerAcessoVisitControlVisitor",
    element: (
      <DomainProvider value={{ domainName: "accesscontrolvisitorsendlog" }}>
        <GerAcessoVisitControlVisitor />
      </DomainProvider>
    ),
  },

  {
    path: "logs/gerAcessoVisitControlSector",
    element: (
      <DomainProvider value={{ domainName: "accesscontrolpacientsendlog" }}>
        <GerAcessoVisitControlSector />
      </DomainProvider>
    ),
  },

  {
    path: "logs/tasyToTasyNonLabExamsAvailable",
    element: (
      <DomainProvider value={{ domainName: "examsendnonlabworklistlog" }}>
        <NonLabExamsAvailable />
      </DomainProvider>
    ),
  },

  {
    path: "logs/tasyToTasyNonLabExamsReceived",
    element: (
      <DomainProvider value={{ domainName: "examsendnonlabworklistlog" }}>
        <NonLabExamsReceived />
      </DomainProvider>
    ),
  },

  {
    path: "logs/serviceReceived",
    element: (
      <DomainProvider value={{ domainName: "servicereceived" }}>
        <ServiceReceived />
      </DomainProvider>
    ),
  },

  {
    path: "logs/tasyToTasyResultsNonLabAvailable",
    element: (
      <DomainProvider value={{ domainName: "ressendnonlabworklistylog" }}>
        <ResultsNonLabAvailable />
      </DomainProvider>
    ),
  },

  {
    path: "logs/tasyToTasyResultsNonLabReceived",
    element: (
      <DomainProvider value={{ domainName: "ressendnonlabworklistzlog" }}>
        <ResultsNonLabReceived />
      </DomainProvider>
    ),
  },

  {
    path: "logs/syncTransaction",
    element: (
      <DomainProvider value={{ domainName: "synctransaction" }}>
        <SyncTransaction />
      </DomainProvider>
    ),
  },

  {
    path: "robots/list",
    element: (
      <DomainProvider value={{ domainName: "robot" }}>
        <RobotsListPage />
      </DomainProvider>
    ),
  },
  {
    path: "robots/list/robot/:id",
    element: (
      <DomainProvider value={{ domainName: "robot" }}>
        <RobotsExecutionsPage />
      </DomainProvider>
    ),
  },

  {
    path: "automations/fileIntegration",
    element: (
      <DomainProvider value={{ domainName: "4uBusAutomationRobot" }}>
        <FileIntegrationPage />
      </DomainProvider>
    ),
  },
  {
    path: "automations/fileIntegration/new",
    element: (
      <DomainProvider
        value={{ domainName: "4uBusAutomationRobot" }}
        actions={["Create"]}
      >
        <FileIntegration />
      </DomainProvider>
    ),
  },
  {
    path: "automations/fileIntegration/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "4uBusAutomationRobot" }}>
        <FileIntegration />
      </DomainProvider>
    ),
  },

  {
    path: "automations/zscanExamSendRule",
    element: (
      <DomainProvider
        value={{ domainName: "extensionestablismenttasysendzscanevo" }}
      >
        <ExamSendRulePage />
      </DomainProvider>
    ),
  },
  {
    path: "automations/zscanExamSendRule/new",
    element: (
      <DomainProvider
        value={{ domainName: "extensionestablismenttasysendzscanevo" }}
      >
        <ExamSendRule />
      </DomainProvider>
    ),
  },
  {
    path: "automations/zscanExamSendRule/:id/edit",
    element: (
      <DomainProvider
        value={{ domainName: "extensionestablismenttasysendzscanevo" }}
      >
        <ExamSendRule />
      </DomainProvider>
    ),
  },

  {
    path: "automations/integrationRule",
    element: (
      <DomainProvider value={{ domainName: "4ubusintegrationrule" }}>
        <IntegrationRulePage />
      </DomainProvider>
    ),
  },
  {
    path: "automations/integrationRule/new",
    element: (
      <DomainProvider value={{ domainName: "4ubusintegrationrule" }}>
        <IntegrationRule />
      </DomainProvider>
    ),
  },
  {
    path: "automations/integrationRule/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "4ubusintegrationrule" }}>
        <IntegrationRule />
      </DomainProvider>
    ),
  },
];

export default bus;
